import React from 'react'
import PropTypes from 'prop-types'

import { _NoResult } from './styles'

const NoResults = ({ className = '' }) =>
  <_NoResult data-test-id="noResults" className={className}>No results</_NoResult>

NoResults.propTypes = {
  className: PropTypes.string,
}
export default NoResults
